var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro-pvtn", {
            attrs: {
              filtro: _vm.filtro,
              placeholder:
                "Informe nº do processo, interessado ou CPF/CNPJ do interessado"
            },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.limpar }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "container cards", attrs: { type: "flex" } },
        [
          _c("app-card-dashboard", {
            style: { marginLeft: 0 },
            attrs: {
              title: "VTN atrasado",
              content: this.dadosCards.totalAtrasado || "0",
              color: "#F96168",
              marginTop: 0
            }
          }),
          _c("app-card-dashboard", {
            style: { marginLeft: 0 },
            attrs: {
              title: "VTN prestes a vencer",
              content: this.dadosCards.totalVencer || "0",
              color: "#FAD36D",
              marginTop: 0
            }
          }),
          _c("app-card-dashboard", {
            style: { marginLeft: 0 },
            attrs: {
              title: "VTN em dia",
              content: this.dadosCards.totalEmDia || "0",
              color: "#009F61",
              marginTop: 0
            }
          })
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("div", { attrs: { id: "tableHeader" } }, [
            _c("h3", { staticStyle: { marginTop: "1%", marginLeft: "1%" } }, [
              _vm._v("Listagem")
            ])
          ]),
          _c("table-generica", {
            attrs: {
              colunas: _vm.colunas,
              botoesAcao: _vm.botoesAcao,
              dados: _vm.dados.content
            }
          }),
          _c(
            "el-row",
            {
              staticClass: "container-switch",
              staticStyle: { marginTop: "1%" },
              attrs: { type: "flex" }
            },
            [
              _c("app-paginacao", {
                attrs: { total: _vm.totalProcessos, pagina: _vm.pagina + 1 },
                on: {
                  changePage: function($event) {
                    return _vm.changePage($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-042f37c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042f37c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/GestaoVtn.vue
// module id = null
// module chunks = 